import Logo2 from "../../assets/logo2.jpeg";
// import Coopérative_socaed from "../../assets/Coopérative_socaed.pptx";
import { HiDownload, HiCheck } from "react-icons/hi";
// import {BsCheckCircleFill} from "react-icons/bs";
// import {FaCheckCircle} from "react-icons/fa"

import Card from "../../components/Cards";
import data from "./data";
import "./about.css";

const About = () => {
  return (
    <section id="about">
      <div className="container about__container">
        <div className="about__left">
          <div className="about__portrait" data-aos="fade-right">
            <img src={Logo2} className="about__photo" alt=" Carti portrait" />
          </div>
          <div>
            <p className="about__ceo">
              {/* <b className="about__ceo_1">Elvis</b>, CEO <br/> */}
              {/* <span className="about__ceo_2">Properties Renovation</span> */}
              <h1>
                Your renovation projects a reality with us.
              </h1>
            </p>
          </div>
        </div>
        <div className="about__right">
          {/* <h2 data-aos="fade-up" className="title">
            Cartri Ltd
          </h2> */}
          <div className="about__cards" data-aos="flip-up">
            {data.map((item) => (
              <Card key={item.id} className="about__card">
                <span className="about__card-icon">{item.icon}</span>
                <h5>{item.title}</h5>
                <small>{item.desc}</small>
              </Card>
            ))}
          </div>

          <span data-aos="fade-up" className="objectives">
            <p>
              <span className="objectives_icon">
                <HiCheck />
              </span>{" "}
             <span className="objectives_desc">Carry out renovation projects, a passion</span> 
            </p>
            <p>
              <span className="objectives_icon">
                <HiCheck />
              </span>{" "}
              <span className="objectives_desc">Make your renovations a success </span> 
            </p>
            <p>
              <span className="objectives_icon">
                <HiCheck />
              </span>{" "}
              <span className="objectives_desc">  Multiple budget-Friendly renovations ideas</span> 
            </p>
            <p>
              <span className="objectives_icon">
                <HiCheck />
              </span>{" "}
              <span className="objectives_desc">  Cost effectiveness, Assessment and Monitoring</span> 
            </p>
          </span>

          <a
            href={"test"}
            download
            className="btn primary"
            data-aos="fade-in"
          >
           <span className="objectives_download"> our prospectus </span> <HiDownload />
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
